module.exports = __webpack_public_path__ + "static/media/6Specialties.e2e5a09b.svg";